// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2llLP","primaryButton":"Button_primaryButton__1dW5m Button_button__2llLP","outlineButton":"Button_outlineButton__1Eu-h Button_button__2llLP"};